import store from "../store/Store";
import { startProcess, stopProcess } from "../store/slices/ApplicationSlice";
import {
  addPatientEndpoint,
  deletePatientEndpoint,
  updatePatientEndpoint,
} from "./api/Patient";

const patients = [];

export const addPatient = async patientData => {
  try {
    const newPatient = patientData;
    const response = await addPatientEndpoint(newPatient);
    return response;
  } catch (error) {
    throw new Error(`Error adding new patient : ${error.message}`);
  }
};

export const searchPatients = async searchCriteria => {
  store.dispatch(startProcess("Start searching"));
  await new Promise(resolve => setTimeout(resolve, 10000));
  store.dispatch(stopProcess());
  return patients;
};

export const getPatientById = async patientId => {
  return patients.find(patient => patient.id === patientId);
};

export const updatePatient = async (updatedPatientData, patientId) => {
  try {
    const response = await updatePatientEndpoint(updatedPatientData, patientId);
    return response;
  } catch (error) {
    throw new Error(`Error updating patient: ${error.message}`);
  }
};

export const deletePatient = async patientId => {
  try {
    store.dispatch(startProcess("Deleting patient"));
    const response = await deletePatientEndpoint(patientId);
    store.dispatch(stopProcess());
    return response;
  } catch (error) {
    store.dispatch(stopProcess());
    throw new Error(`Error deleting patient: ${error.message}`);
  }
};
